module.exports = __webpack_public_path__ + "img/icons.4b4de389.svg";